/* istanbul ignore file */
export default function getBase64FileType(base64String: string): string {
  try {
    return base64String.split(";")[0].split("/")[1];
  } catch {
    return base64String;
  }
}
